import { getUrlParams, commonParseQuery, parseJson } from './common-utils';

export const parseTime = (time: string) => time + (parseInt(time, 10) < 12 ? ' AM' : ' PM');

const parseResultsPageUrlToConfig = (url) => {
  const searchParams = getUrlParams(url);
  const { qryParams = '{}', filters = '', utm_medium = "",utm_campaign="" } = searchParams;
  const parsedJson = parseJson(qryParams);
  const { s_n, s_i, d_n, d_i, s_t, e_t, t_t = "ONE_WAY", rf = "ow", s_c = "", off = 0, r_off = 0, pc = "", flow = "", isSeo = false, package_id = '', d_c = '', s_l = {}, d_l = '', s_s, d_s } = parsedJson;
  const { newSDate, newSTime, newEDate, newETime } = commonParseQuery({ s_t, e_t, off, r_off });
  const parseData = {
    startDate: {
      date: newSDate,
      time: newSTime[0]
    },
    endDate: {
      date: newEDate,
      time: newETime[1]
    },
    source: {
      name: s_n,
      place_id: s_i,
      city_name: s_c,
      locus: s_l,
      state: s_s,
    },
    destination: {
      name: d_n,
      place_id: d_i,
      city_name: d_c,
      locus: d_l,
      state: d_s
    },
    tripType: {
      name: e_t || r_off ? 'ROUND_TRIP' : t_t,
      rf: e_t || r_off ? 'rt' : rf
    },
    filters: null,
    flow,
    pc,
    isSeo: !!isSeo,
    package_id
  };
  if (filters) {
    const parsedJson = parseJson(filters);
    if (Object.keys(parsedJson).length > 0) {
      parseData['filters'] = parsedJson;
    }
  }
  if (utm_medium && utm_medium === 'cpc') {
    parseData['sem_flow'] = true;
    parseData['utm_medium'] = utm_medium;
    parseData['utm_campaign'] = utm_campaign;
    
  }
  const srcConfig = ["ChIJARFGZy6_wjsRQ-Oenb9DjYI","ChIJpQoX1dIJGToRqD-zaCsOWPw","ChIJtRyXL69ZqDsRgtI-GB7IwS8","ChIJL_P_CXMEDTkRw0ZdG-0GVvw","ChIJ2UEvfIUNdDkRQjtSqTjvSng"]
  const destConfig = ["ChIJwe1EZjDG5zsRaYxkjY_tpF0","ChIJleRWAhjEGToR1_rBMIudakk","ChIJjdfztYS9qDsRQj8-yRTbmxc","ChIJL_P_CXMEDTkRw0ZdG-0GVvw","ChIJ2UEvfIUNdDkRQjtSqTjvSng"]
  if(s_i && srcConfig.indexOf(s_i) !== -1 && d_i && destConfig.indexOf(d_i) !== -1){
    parseData['showQueryCB'] = true;
  }
  return parseData;
}


export default parseResultsPageUrlToConfig;